module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-quote-fill-08d07bc7.svg";